'use strict';

import React from 'react';

export default function ErrorPage404 (props) {
  return (
    <div className='page-content'>
      <table style={{width: '700px', margin: '50px auto'}}>
        <tr style={{verticalAlign: 'top'}}>
          <td>
            <h1 style={{padding: '0', fontSize: '150px', margin: '0'}}>
              <span style={{color: '#ff7f29'}}>4</span>
              <span style={{color: '#94c133'}}>0</span>
              <span style={{color: '#749b09'}}>4</span>
            </h1>

            <h2 style={{padding: '0'}}>К сожалению, запрашиваемой вами страницы не существует.</h2>
          </td>
          <td style={{verticalAlign: 'top', minWidth: '345px'}}>
            <h3>Возможно:</h3>

            - вы ошиблись при наборе адреса страницы;<br />
            - вы перешли по неработающей ссылке;<br />
            - запрашиваемой страницы никогда не было или она была удалена.<br />

            <h3>Мы предлагаем следующие пути:</h3>

            - проверить правильность написания адреса страницы;<br />
            - перейти на <a href='/' style={{color: '#ff7f29'}}>главную страницу</a>;<br />
            - воспользоваться навигационным меню сайта.<br />

            <p>С уважением, администрация сайта МЛСН.ру</p>
          </td>
        </tr>
      </table>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/ui/Pages/Errors/404.jsx